import ptPlusApiBaseUrl from 'api/ptPlusApiBaseUrl';
import { showAppLoader, hideAppLoader } from '../app';

export const ptPlusVendorPricingAddData = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/delivery_pricing/create`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusVendorPricingAddMoreVendorData = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/delivery_pricing/update`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusVendorPricingGetCustomerFee = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/delivery_pricing/fetch_customer_flat_fee`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusVendorPricingGetFlatFee = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/delivery_pricing/fetch_flat_fee_details`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusVendorPricingList = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/delivery_pricing/list`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const ptPlusVendorFeeItemDelete = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.delete(`ptms/delivery_pricing/delete`, {
    data,
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};